export const GOOGLE_RECAPTCHA_DEV_ENV_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
export const GOOGLE_RECAPTCHA_PROD_ENV_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
